'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var febDatePickerComponent = exports.febDatePickerComponent = {
    transclude: true,
    template: require('./date-picker.html'),
    bindings: {
        value: '=',
        maxDate: '<',
        minDate: '<',
        onChange: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.valueChanged = valueChanged;

        function valueChanged(event) {
            vm.onChange({ $event: event });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/common/date-picker.js
// module id = 913
// module chunks = 0